import React from 'react';
import { useAuth } from '../context/AuthContext';

const NAV_ITEMS = [
  { id: 't2i', icon: '🖼', label: 'T2I', sub: '텍스트→이미지', color: 'var(--accent)',  bg: 'rgba(0,255,136,0.1)' },
  { id: 'i2i', icon: '✏️', label: 'I2I', sub: '이미지→이미지', color: 'var(--accent4)', bg: 'rgba(0,188,212,0.1)' },
  { id: 't2v', icon: '🎥', label: 'T2V', sub: '텍스트→영상',   color: 'var(--accent3)', bg: 'rgba(102,68,255,0.1)' },
  { id: 'i2v', icon: '🎬', label: 'I2V', sub: '이미지→영상',   color: 'var(--accent2)', bg: 'rgba(255,51,102,0.1)' },
  { id: 'r2v', icon: '🎭', label: 'R2V', sub: '참조→영상',     color: 'var(--accent5)', bg: 'rgba(255,149,0,0.1)'  },
];

export default function Sidebar({ activeTab, onTabChange, historyCount, onHistoryToggle, showHistory }) {
  const { logout } = useAuth();

  return (
    <>
      {/* ── 데스크톱 사이드바 ── */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <span className="sidebar-logo-icon">◈</span>
          <span>
            <span className="sidebar-logo-text">
              GROK<span className="sidebar-logo-accent">STUDIO</span>
            </span>
            <span className="sidebar-logo-v2">V2</span>
          </span>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section-label">생성 모드</div>
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
              style={activeTab === item.id ? {
                '--nav-active-bg': item.bg,
                '--nav-active-color': item.color,
              } : {}}
              onClick={() => onTabChange(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">
                <span className="nav-label-main">{item.label}</span>
                <span className="nav-label-sub">{item.sub}</span>
              </span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button
            className={`sidebar-history-btn ${showHistory ? 'active' : ''}`}
            onClick={onHistoryToggle}
          >
            <span>📋</span>
            <span>히스토리</span>
            {historyCount > 0 && (
              <span className="history-badge">{historyCount}</span>
            )}
          </button>
          <button className="sidebar-logout-btn" onClick={logout}>
            <span>⏻</span>
            <span>로그아웃</span>
          </button>
        </div>
      </aside>

      {/* ── 모바일 상단 헤더 ── */}
      <div className="mobile-header">
        <div className="mobile-header-logo">
          <span className="sidebar-logo-icon" style={{ fontSize: '16px' }}>◈</span>
          <span className="sidebar-logo-text" style={{ fontSize: '18px', letterSpacing: '2px' }}>
            GROK<span className="sidebar-logo-accent">STUDIO</span>
          </span>
          <span className="sidebar-logo-v2">V2</span>
        </div>
        <div className="mobile-header-actions">
          <button
            className={`mobile-header-btn ${showHistory ? 'active' : ''}`}
            onClick={onHistoryToggle}
          >
            📋
            {historyCount > 0 && (
              <span className="mobile-badge">{historyCount > 9 ? '9+' : historyCount}</span>
            )}
          </button>
          <button className="mobile-header-btn mobile-header-logout" onClick={logout}>⏻</button>
        </div>
      </div>

      {/* ── 모바일 하단 탭바 ── */}
      <nav className="mobile-tabbar">
        {NAV_ITEMS.map(item => (
          <button
            key={item.id}
            className={`mobile-tab ${activeTab === item.id ? 'active' : ''}`}
            style={activeTab === item.id ? {
              '--tab-color': item.color,
              '--tab-bg': item.bg,
            } : {}}
            onClick={() => onTabChange(item.id)}
          >
            <span className="mobile-tab-icon">{item.icon}</span>
            <span className="mobile-tab-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
}
